import React from "react";
import { useQuery } from "react-query";

import Loading from "src/components/Loading";
import { getSection } from "src/hooks/useContentful/getSection";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";

import contentfulClient from "src/services/contentful";
import useMedia from "use-media";
import Carroussel from "./Carroussel";
import Item from "./Item";
import { ContainerListButton, InnerContainer } from "./styles";

function Steps() {
	const isMd = useMedia({ minWidth: 1024 });
	const content = useFetchContent();
	const section = getSection({
		sectionName: "landingStepperSection",
		data: content.data,
	});

	const { data, isLoading } = useQuery(
		"getSteps",
		() =>
			Promise.all(
				section.steps.map(
					async (step) => await contentfulClient.getEntry(step.sys.id)
				)
			),
		{
			enabled: content.data && !content.isLoading,
		}
	);

	if (content.isLoading || !content.data || isLoading || !data)
		return <Loading />;

	//const list = data.map(({ fields }, index) => <Item item={fields} key={index} />);

	const newData = () => {
	return 	[
		{
			 "fields":{
					"componentName":"Adquira - Bradesco Classic",
					"title":"Passe direto por pedágios",
					"description":"A tag Veloe é aceita em 100% das rodovias brasileiras",
					"image":{
						 "fields":{
								"title":"Adquira Icon",
								"description":"",
								"file":{
									 "url": '/bradescoclassic/assets/beneficios_car.svg',
									 "details":{
											"size":407,
											"image":{
												 "width":59,
												 "height":59
											}
									 },
									 "fileName":"ver-mais-icone.svg",
									 "contentType":"image/svg+xml"
								}
						 }
					},
					"textColor":"#ffffff",
					"titleColor":"#ffffff"
			 }
		},
		{
			 "fields":{
					"componentName":"Ative - Bradesco Classic",
					"title":"Estacione com praticidade",
					"description":"São mais de 2 mil estacionamentos credenciados, distribuídos por aeroportos, shoppings e centros comerciais",
					"image":{
						 "fields":{
								"title":"Ative Icon",
								"description":"",
								"file":{
									 "url":'/bradescoclassic/assets/beneficios_e.svg',
									 "details":{
											"size":3229,
											"image":{
												 "width":59,
												 "height":65
											}
									 },
									 "fileName":"mobile-icone.svg",
									 "contentType":"image/svg+xml"
								}
						 }
					},
					"textColor":"#ffffff",
					"titleColor":"#ffffff"
			 }
		},
		{
			 "fields":{
					"componentName":"Como usar - Bradesco Classic",
					"title":"Recarga Automática",
					"description":"Na contratação da sua tag, escolha o valor de recarga automática que preferir e selecione o seu cartão de Crédito ou Débito Bradesco.",
					"image":{
						 "fields":{
								"title":"Como usar",
								"description":"",
								"file":{
									 "url":'/bradescoclassic/assets/beneficios_flags.svg',
									 "details":{
											"size":2241,
											"image":{
												 "width":64,
												 "height":53
											}
									 },
									 "fileName":"pedagio-icone.svg",
									 "contentType":"image/svg+xml"
								}
						 }
					},
					"textColor":"#ffffff",
					"titleColor":"#ffffff"
			 }
		},
		{
			"fields":{
				 "componentName":"Como usar - Bradesco Classic",
				 "title":"Aproveite o Clube de Vantagens",
				 "description":"Garanta descontos em serviços e produtos exclusivos para clientes Bradesco e Veloe.",
				 "image":{
						"fields":{
							 "title":"Como usar",
							 "description":"",
							 "file":{
									"url":'/bradescoclassic/assets/beneficios_porcentage.svg',
									"details":{
										 "size":2241,
										 "image":{
												"width":64,
												"height":53
										 }
									},
									"fileName":"pedagio-icone.svg",
									"contentType":"image/svg+xml"
							 }
						}
				 },
				 "textColor":"#ffffff",
				 "titleColor":"#ffffff"
			}
	 }
 ]
	}

 const list = newData().map(({ fields }, index) => <Item item={fields} key={index} />);

	return (
		<InnerContainer>
				{isMd ? (
					<ContainerListButton>
						{newData().map(({ fields }, index) => (
								<Item key={index} item={fields} index={index} />
							))}
					</ContainerListButton>
					) : (
						<Carroussel list={list} />
					)}
		</InnerContainer>
	);
}

export default Steps;